module.exports = __webpack_public_path__ + "img/logos_enes020.7b753d0b.png";